import { random, LOWER, NUMBER } from "./random";

export const generateId = () => {
	return random(1, LOWER) + random(4, LOWER + NUMBER);
};
